module.exports = __webpack_public_path__ + "static/media/numioLight.b57be802.png";